define('app-Search/modules/oceanCruise/viewmodel',["util"], function (util) {
    return {
        target: $("#searchTab4"),
        run: function (settings) {
            var appTags = '{"type":"ht","value":"ead58222-b526-4d6c-9102-ab95ed4b0304","description":"Ocean Cruise"}',
                compiledSearch = "";

            function compileOceanCruiseSearch(usedestination) {
                var searchQuery = [];

                searchQuery.push(appTags);

                var numberPassengers = $("#oceanCruisePassengers").val();
                if (numberPassengers) searchQuery.push(decodeURIComponent(numberPassengers));

                if (usedestination == undefined || usedestination == true) {
                    var searchQueryValue = $("#oceanCruiseSearchContentSelect").val();

                    if (searchQueryValue) searchQuery.push(decodeURIComponent(searchQueryValue));
                }

                var oceanCruiseDuration = $("#oceanCruiseDuration").val();
                if (oceanCruiseDuration) searchQuery.push(decodeURIComponent(oceanCruiseDuration));
                
                var oceanCruiseDepartures = $("#oceanCruiseDepartures").val();
                if (oceanCruiseDepartures && oceanCruiseDepartures.length > 0) searchQuery.push(decodeURIComponent(oceanCruiseDepartures));

                var dates = $("#ocDateField").val();
                var urlEncodedDates = availableDatesDictionary[dates];
                if (urlEncodedDates) searchQuery.push(urlEncodedDates);

                return searchQuery;
            }

            function getOceanCruiseDepartures(defaultOceanRegion) {
                if ((window.location.pathname.toLowerCase() === "/search"
                    || window.location.pathname.toLowerCase().endsWith("/search"))
                    && compiledSearch == "") {
                    var hashData = $(location).attr('hash');

                    if (hashData != "") {
                        var startAt = hashData.indexOf('[');

                        if (startAt >= 0) {
                            var endAt = hashData.lastIndexOf(']'),
                                searchTagsRaw = hashData.substring(startAt, endAt + 1),
                                searchTags = decodeURIComponent(searchTagsRaw);

                            if (searchTags != "") {
                                compiledSearch = JSON.stringify(JSON.parse(searchTags));
                            }
                        }
                    }
                } else {
                    compiledSearch = compileOceanCruiseSearch().toString();
                }

                var isocean = compiledSearch.indexOf(appTags) >= 0;

                $('#oceanCruiseSearchContentSelect option').slice(1).remove();
                $('#oceanCruiseDepartures option').remove();
                

                var urldata = (isocean ? compileOceanCruiseSearch(false).toString() : appTags);

                $.ajax({
                    url: settings.oceanSearchData,
                    data: { tags: "[" + urldata + "]" },
                    type: "POST",
                    success: function (data) {
                        // write out the cruise regions
                        var cruiseData = resources_getObjects(data, 'description', 'Cruise region');

                        cruiseData[0].collection.forEach(function (obj) {
                            var stringObj = new Object();
                            stringObj.type = obj.type;
                            stringObj.value = obj.value;
                            stringObj.description = obj.description;

                            // test against compiledSearch to see if value exists and if so check / select - .prop("selected", selected);
                            //If the page has a default region, set that region. Done here in order to negate sending stats to analytics.
                            var defaultRegionSet = typeof(defaultOceanRegion) !== "undefined" && defaultOceanRegion.length > 0,
                                selected = isocean && (compiledSearch.indexOf(obj.value) >= 0 || (defaultRegionSet && obj.value.indexOf(defaultOceanRegion) > -1)),
                                optionValue = encodeURIComponent(JSON.stringify(stringObj)),
                                option = $('<option>').val(optionValue).html("|(" + obj.matches + ')|' + obj.description).prop("selected", selected);

                            if (defaultRegionSet && selected)
                                $('#oceanCruiseSearchButton').val("See " + obj.matches + (obj.matches > 1 ? " cruises" : " cruise"));

                            $('#oceanCruiseSearchContentSelect').append(option);
                        });

                        // sumoselect is now loaded by app-formElements/main.js
                        // but the AJAX hasn't run to populate the list yet, so reload it
                        $('#oceanCruiseSearchContentSelect')[0].sumo.reload();

                        //then delete the numbers from the original option list because they're ugly
                        $('#oceanCruiseSearchContentSelect > option').html(function (index, html) { return html.replace(/(\|\([\d]*\)\|)/g, ""); });

                        // and delete the match numbers the caption container - eq(0) gets the correct element of the three matches
                        $('#oceanCruiseSearchContent .CaptionCont').eq(0).html(function (index, html) { return html.replace(/(\|\([\d]*\)\|)/g, ""); });

                        // write out the departure points
                        var departurePoints = resources_getObjects(data, 'description', 'Departure ports');

                        departurePoints[0].collection.forEach(function (obj) {
                            var option = '<option class="group-head depPt_' + obj.description.replace(/ /g, '') + '" disabled>' + obj.description + '</option>',
                                showOptgroup = 0;
                            $('#oceanCruiseDepartures').append(option);                            

                            // child elements
                            if (obj.count > 0) {
                                obj.children.forEach(function (child) {
                                    var childObj = new Object();
                                    childObj.type = child.type;
                                    childObj.value = child.value;
                                    childObj.description = child.description;

                                    // test against compiledSearch to see if value exists and if so check / select - .prop("selected", selected);
                                    var selected = (compiledSearch.indexOf(child.value) >= 0 && isocean) ? true : false,
                                        optionValue = encodeURIComponent(JSON.stringify(childObj)),
                                        childOption = $('<option>').val(optionValue).html("|(" + child.matches + ')|' + child.description).prop("selected", selected);

                                    if (child.matches > 0) {
                                        showOptgroup = 1;
                                        $('#oceanCruiseDepartures').append(childOption);
                                    };
                                });
                            }

                            if (showOptgroup == 0) {
                                var selectElem = '#oceanCruiseDepartures .depPt_' + obj.description.replace(/ /g, '');
                                $(selectElem).remove();
                            }
                        });

                        // and delete the match numbers the caption container - eq(3) gets the correctly matched element.
                        $('#oceanCruiseSearchContent .CaptionCont').eq(3).html(function (index, html) { return html.replace(/(\|\([\d]*\)\|)/g, ""); });

                        //finally replace the codes around the number of matches so they come thru as spans
                        $("#searchControl").find('.options > li > label').html(function (index, html) {
                            html = html.replace("|(", "<span>");
                            html = html.replace(")|", "</span>");
                            return html;
                        });
                    },
                    fail: function () {
                        console.log("Error retrieving data from server");
                    }
                });           
            }

            $("#oceanCruiseSearchButton").on("click", function () {
                //update the ADL and make the direct call
                AdlAddUpdateItem('BHsearchMethodWidgetType', 'search_panel_oceancruise');
                AdlAddUpdateItem('BHsearchMethodLinkType', 'cta');
                AdlAddUpdateItem('BHsearchMethodPagePosition', 'header');
                AdlAddUpdateItem('BHsearchMethodPageType', 'homepage');
                util.satelliteTrack('travelSearchWidget');

                var productCount = 0;

                $.ajax({
                    url: settings.resultCountUrl,
                    data: { "tags": "[" + compileOceanCruiseSearch().toString() + "]" },
                    type: "POST",
                    success: function (data) {
                        productCount = data.productCount;
                    },
                    async: false
                });

                if (productCount === 1) {
                    redirectToProductPage();
                } else {
                    var forceReload = Math.random();
                    window.location.href = '/cruises/search?' + forceReload + '#' + settings.searchUrlKey + '|[' + compileOceanCruiseSearch().toString() + ']||';
                }
            });

            function redirectToProductPage() {
                $.ajax({
                    url: settings.getResultsUrl,
                    data: { "tags": "[" + compileOceanCruiseSearch().toString() + "]" },
                    type: "POST",
                    success: function (data) {
                        window.location.href = data.paginatedResults[0].url;;
                    },
                    async: false
                });
            }

            $('#ocDateField').focus(function (e) {
                showDatePicker('#ocDateField', compileOceanCruiseSearch().toString());

                $(this).next().slideToggle();
                $(this).blur();
                $('.ocDateField .dateDropdown').toggleClass("activeDropdown");
            });

            // when something changes update the search button text
            $('.ocChangeTrigger').change(function () {
                $.ajax({
                    url: settings.resultCountUrl,
                    data: { 'tags': '[' + compileOceanCruiseSearch().toString() + ']' },
                    type: "POST",
                    success: function (data) {
                        var text = "See " + data.productCount + (data.productCount > 1 ? " cruises" : " cruise");
                        $('#oceanCruiseSearchButton').val(text);
                    }
                });

                getOceanCruiseDepartures();

                if ($(this).hasClass('passengers')) {
                    //passengers has been changed
                    var passObj = decodeURIComponent($('#oceanCruisePassengers').val());
                    var passJson = $.parseJSON(passObj);
                    AdlAddUpdateItem('editSearchPassengerNumber', passJson.value);
                    util.satelliteTrack('search results edit');
                };

                if ($(this).hasClass('duration')) {
                    //duration has been changed
                    var passObj = decodeURIComponent($('#oceanCruiseDuration').val());
                    var passJson = $.parseJSON(passObj);
                    AdlAddUpdateItem('editSearchTravelDuration', passJson.value);
                    util.satelliteTrack('search results edit');
                };

                if ($(this).closest('.ocDateField ').siblings('dateDropdown')) {
                    //duration has been changed
                    AdlAddUpdateItem('editSearchTravelDate', $('#ocDateField').val());
                    util.satelliteTrack('search results edit');
                };

                if ($(this).hasClass('locationField')) {
                    //location has been changed
                    if ($('#oceanCruiseSearchContentSelect').val() == "") {
                        AdlAddUpdateItem('editSearchDestination', '');
                    } else {
                        var passObj = decodeURIComponent($('#oceanCruiseSearchContentSelect').val());
                        var passJson = $.parseJSON(passObj);
                        AdlAddUpdateItem('editSearchDestination', passJson.value);
                    };

                    util.satelliteTrack('search results edit');
                };

            });

            var defaultOceanRegion = $('#oceanCruiseSearchContentSelect').data("default-region");
            getOceanCruiseDepartures(defaultOceanRegion); //initialising call
        }
    };
});
